import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {fuseAnimations} from '@fuse/animations';
import {InfoDialogData} from './info-dialogt.types';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { BypassSecurityTrustHtmlPipe } from '../../pipes/bypass-security-trust-html.pipe';

@Component({
    selector: 'app-info-dialog',
    templateUrl: './info-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [MatIconButton, MatIcon, BypassSecurityTrustHtmlPipe]
})
export class InfoDialogComponent implements OnInit {

    public title: string;
    public message: string;

    constructor(
        public dialogRef: MatDialogRef<InfoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) {title, message}: InfoDialogData
    ) {
        this.title = title;
        this.message = message;
    }

    ngOnInit(): void {
    }

}
